import { render, staticRenderFns } from "./lecture-view.vue?vue&type=template&id=5c3f6f70"
import script from "./lecture-view.vue?vue&type=script&lang=js"
export * from "./lecture-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports